import { CommunityMembershipNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { FormattedText, Typography } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { prepareHubItemTitle } from "./AnnouncementActivity";

export type CommunityMembershipActivityProps = {
	data: CommunityMembershipNotificationDataViewModel;
};

export const CommunityMembershipActivity = (props: CommunityMembershipActivityProps): ReactElement => {
	const { data } = props;

	return (
		<span {...setTrackingId("title")}>
			<FormattedText
				text={localize("_YouHaveBeenAddedAsAMemberOfCommunityName")}
				thingsToReplace={[
					{
						what: "{{CommunityName}}",
						filler: (
							<Typography
								trackingId="community-name"
								weight="bold"
							>
								{prepareHubItemTitle(data.name)}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};
CommunityMembershipActivity.displayName = "CommunityMembershipActivity";